/* eslint-disable block-scoped-var, no-redeclare */
'use strict';

var scrollAnimate = require('./scrollAnimate');
var phoneValidation = require('./phoneValidation');
var isValidUSPhone = phoneValidation.isValidUSPhone;
var formatPhoneNumber = phoneValidation.formatPhoneNumber;

/**
 * Validate whole form. Requires `this` to be set to form object
 * @param {jQuery.event} event - Event to be canceled if form is invalid.
 * @returns {boolean} - Flag to indicate if form is valid
 */
function validateForm(event) {
    var valid = true;
    var isUS = phoneValidation.isUSLocale();

    $(this).find('input, select').each(function () {
        var value = $(this).val();
        var inputID = $(this).attr('id');
        var isPhoneInput = inputID && inputID.toLowerCase().indexOf('phone') > -1;

        if (isUS && isPhoneInput && value.length) {
            var isValidUSPhoneResult = isValidUSPhone($(this), 'eq');
            var countryCodeErrorMessage = $(this).data('countrycode-error-message');
            if (countryCodeErrorMessage && !isValidUSPhoneResult) {
                // safari
                if (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                }

                valid = false;
                $(this).trigger('invalid', this.validity);
            }
        }

        var excludedValid = true;
        var excludeRegExp = $(this).data('pattern-exclude') ? new RegExp($(this).data('pattern-exclude')) : null;

        if (excludeRegExp && $(this).val()) {
            if (excludeRegExp.test($(this).val())) {
                excludedValid = false;
            }
        }

        var globaleCountry = false;
        if ($(this).hasClass('shippingCountry') && $(this).hasClass('ge-country')) {
            globaleCountry = true;
        }

        if (!(this.validity.valid && excludedValid) || globaleCountry) {
            // safari
            if (event) {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
            }

            valid = false;
            $(this).trigger('invalid', this.validity);
        }
    });

    if (!valid) {
        var $firstInvalid = $(this).find('input.is-invalid:first, select.is-invalid:first');
        scrollAnimate($firstInvalid);
        $firstInvalid.data('skip-focusin-clear', true);
        $firstInvalid.trigger('focus');
    }

    return valid;
}

/**
 * Validate whole form. Requires `this` to be set to form object
 * @param {jQuery.event} event - Event to be canceled if form is invalid.
 * @returns {boolean} - Flag to indicate if form is valid
 */
function formValidate(event) {
    var valid = true;
    if (this[0].checkValidity && !this[0].checkValidity()) {
        // safari
        valid = false;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        }
        $(this).find('input, select').each(function () {
            if (!this.validity.valid) {
                $(this).trigger('invalid', this.validity);
            }
        });
        scrollAnimate($(this).find('.is-invalid:first'));
    }
    return valid;
}

/**
 * Validate a form element. Requires `this` to be set to form object
 * @param {jQuery.event} event - Event to be canceled if form is invalid.
 * @returns {boolean} - Flag to indicate if form is valid
 */
function validateFormElement(event) {
    var valid = true;
    var excludedValid = true;
    var excludeRegExp = $(this).data('pattern-exclude') ? new RegExp($(this).data('pattern-exclude')) : null;
    var eventType = event ? event.type : null;

    if (excludeRegExp && $(this).val()) {
        if (excludeRegExp.test($(this).val())) {
            excludedValid = false;
        }
    }

    if ($(`[data-must-match=${$(this).attr('id')}]`).length && $(this).val()) {
        validateFormElement.call($(`[data-must-match=${$(this).attr('id')}]`)[0], event);
    }

    if (($(this).data('must-match') && $('#' + $(this).data('must-match')).length)
        && $('#' + $(this).data('must-match')).val().length
        && $(this).val() !== $('#' + $(this).data('must-match')).val()) {
        if ($(this).data('match-error')) {
            $(this).data('custom-error', ($(this).data('match-error')));
        } else {
            $(this).data('custom-error', 'Fields do not match');
        }
        $(this).trigger('invalid', this.validity);
        return false;
    }

    // check country
    var globaleCountry = null;
    if ($(this).hasClass('shippingCountry')) {
        var getGlobaleCountry = require('../checkout/shipping').methods.getGlobaleCountry;
        globaleCountry = getGlobaleCountry($(this).val());
        if (eventType === 'change') {
            var handleGlobaleCountry = require('../checkout/shipping').methods.handleGlobaleCountry;
            handleGlobaleCountry($(this).val());
        }
    }

    if ((this.checkValidity && !this.checkValidity()) || !excludedValid || globaleCountry) {
        // safari
        valid = false;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!this.validity.valid || !excludedValid || globaleCountry) {
            if (($(this).siblings('.invalid-feedback').children().length === 0) || ($(this).siblings('.invalid-feedback').css('display') === 'none')) {
                $(this).trigger('invalid', this.validity);
            } else {
                $(this).trigger('invalid', this.validity);
                $(this).addClass('is-invalid');
                $(this).parent().addClass('is-invalid');
            }
            if (event.type !== 'focusout') {
                scrollAnimate($(this));
            }
        }
    }
    if (this.validity.valid && excludedValid && !globaleCountry) {
        $(this).parent().find('.invalid-feedback').hide();
        $(this).removeClass('is-invalid');
        $(this).parent().removeClass('is-invalid');
    }
    return valid;
}
$(document).on('click', '.request-password-close-btn', function () {
    $('input').parent().find('.invalid-feedback').hide();
    $('input').removeClass('is-invalid');
    $('.reset-password-form').trigger('reset');
});
$(document).on('focusin', 'input', function () {
    if ($(this).data('skip-focusin-clear')) {
        $(this).removeData('skip-focusin-clear');
        // Remove aria-describedby so NVDA doesn't read the error description on
        // this programmatic focus — the flip-trick live region is the sole announcer.
        $(this).removeAttr('aria-describedby');
        return;
    }
    $(this).parent().find('.invalid-feedback').text('');
    $(this).removeClass('is-invalid')
        .removeAttr('aria-invalid')
        .removeAttr('aria-describedby');
});

$(document).on('click', '.signin', function () {
    if (!$('input').hasClass('is-invalid')) {
        $('input:not(is-invalid)').parent().find('.invalid-feedback').hide();
    }
});

$(document).on('click', 'button[data-custom-form-name]', function (e) {
    var customFormName = $(this).data('custom-form-name');
    var $customForm = $('form[name="' + customFormName + '"]');
    if ($customForm.length && $customForm[0].hasAttribute('novalidate')) {
        return;
    }
    validateForm.call($('form[name="' + customFormName + '"]')[0], e);
});

// Allow only '+' and numbers on country code prefix input field
$(document).ready(function () {
    $('.validatePrefixField').on('input blur', function () {
        var inputValue = $(this).val();
        if (inputValue) {
            $(this).val('+' + inputValue.replace(/[^0-9]/g, '').substring(0, 6));
        }
    });
});

/**
 * Remove all validation. Should be called every time before revalidating form
 * @param {element} form - Form to be cleared
 * @returns {void}
 */
function clearForm(form) {
    $(form).find('.form-control.is-invalid')
        .removeClass('is-invalid')
        .removeAttr('aria-invalid')
        .removeAttr('aria-describedby');
    $(form).find('.invalid-feedback').hide();
}

module.exports = {
    invalid: function () {
        $(document).on('invalid', 'input, form input, form select', function (e) {
            e.preventDefault();
            this.setCustomValidity('');
            var alertPrefix;
            var validationMessage;
            var value = $(this).val();
            var inputID = $(this).attr('id');
            var isPhoneInput = inputID && inputID.toLowerCase().indexOf('phone') > -1;
            var isUS = phoneValidation.isUSLocale();
            var excludeRegExp = $(this).data('pattern-exclude') ? new RegExp($(this).data('pattern-exclude')) : null;
            var excludedValid = true;

            if (isUS && isPhoneInput && value.length) {
                var isValidUSPhoneResult = isValidUSPhone($(this), 'eq');
                var countryCodeErrorMessage = $(this).data('countrycode-error-message');

                if (countryCodeErrorMessage && !isValidUSPhoneResult) {
                    validationMessage = countryCodeErrorMessage;
                }
            }

            if ($(this).hasClass('shippingCountry') && $(this).hasClass('ge-country')) {
                validationMessage = $(this).data('globale-error-message');
            }

            if (excludeRegExp && value) {
                if (excludeRegExp.test(value)) {
                    excludedValid = false;
                }
            }

            if (validationMessage) {
                $(this).addClass('is-invalid').attr('aria-invalid', 'true');
                $(this).parent().find('.invalid-feedback').show();
                var $invalidFeedback = $(this).parents('.form-group').find('.invalid-feedback');
                alertPrefix = $invalidFeedback.hasClass('sr-alert') ? '<span class="sr-only">alert </span>' : '';
                $invalidFeedback.html(`<i class="fa fa-exclamation-circle error-message-icon" aria-hidden="true"></i><span>${alertPrefix}${validationMessage}</span>`);
            } else if (!this.validity.valid || !excludedValid) {
                validationMessage = this.validationMessage;
                var patternExclude = $(this).hasClass('pattern-exclude');
                if ((this.validity.patternMismatch && $(this).data('pattern-mismatch') && !patternExclude) || !excludedValid) {
                    validationMessage = $(this).data('pattern-mismatch');
                }
                if ((this.validity.rangeOverflow || this.validity.rangeUnderflow)
                    && $(this).data('range-error')) {
                    validationMessage = $(this).data('range-error');
                }
                if ((this.validity.tooLong || this.validity.tooShort)
                    && $(this).data('range-error')) {
                    validationMessage = $(this).data('range-error');
                }
                if (this.validity.valueMissing && $(this).data('missing-error')) {
                    validationMessage = $(this).data('missing-error');
                }

                if (validationMessage) {
                    $(this).addClass('is-invalid').attr('aria-invalid', 'true');
                    $(this).parent().find('.invalid-feedback').show();
                    var labelInvalidFeedback = $(this).parents('.form-group').find('.invalid-feedback');
                    alertPrefix = labelInvalidFeedback.hasClass('sr-alert') ? '<span class="sr-only">alert </span>' : '';
                    if (($(this).attr('id') === 'login-form-email' || $(this).data('parse-error')) && this.validity.typeMismatch) {
                        validationMessage = $(this).data('parse-error') || 'Please enter a valid email';
                        labelInvalidFeedback
                            .html('<i class="fa fa-exclamation-circle error-message-icon" aria-hidden="true"></i><span>' + validationMessage + '</span>');
                    } else if ($(this).attr('id') === 'login-form-email' && this.validity.valueMissing) {
                        validationMessage = 'Please enter your account email';
                        labelInvalidFeedback
                            .html('<i class="fa fa-exclamation-circle error-message-icon" aria-hidden="true"></i><span>Please enter your account email</span>');
                    } else if ($(this).attr('id') === 'login-form-password' && this.validity.valueMissing) {
                        validationMessage = 'Please enter your account password';
                        labelInvalidFeedback
                            .html('<i class="fa fa-exclamation-circle error-message-icon" aria-hidden="true"></i><span>Please enter your account password</span>');
                    } else {
                        labelInvalidFeedback
                            .html(`<i class="fa fa-exclamation-circle error-message-icon" aria-hidden="true"></i><span>${validationMessage}</span>`);
                    }
                    $(this).parent().find('.invalid-feedback').focus();
                } else if (isPhoneInput) {
                    formatPhoneNumber($(this));
                }
            } else if ($(this).data('custom-error')) {
                $(this).addClass('is-invalid').attr('aria-invalid', 'true');
                var $customInvalidFeedback = $(this).parent().find('.invalid-feedback');
                alertPrefix = $customInvalidFeedback.hasClass('sr-alert') ? '<span class="sr-only">alert </span>' : '';
                $customInvalidFeedback.html(`<i class="fa fa-exclamation-circle error-message-icon" aria-hidden="true"></i><span>${alertPrefix}${$(this).data('custom-error')}</span>`);
                $customInvalidFeedback.show();
                validationMessage = $(this).data('custom-error');
            }

            // Inject a fresh role="alert" element for each announcement. A new element
            // has no prior ARIA state, so NVDA always announces it exactly once with the
            // "Alert" prefix. Inline text-transform:none overrides any site CSS that
            // would make NVDA read the text in uppercase. window.pmAnnouncePending
            // prevents repeated announcements when multiple fields are invalid at once.
            if (validationMessage && !window.pmAnnouncePending) {
                window.pmAnnouncePending = true;
                setTimeout(function () { window.pmAnnouncePending = null; }, 300);
                var $alertEl = $('<div>', { role: 'alert', 'aria-atomic': 'true' })
                    .addClass('sr-only')
                    .css('text-transform', 'none')
                    .text(validationMessage);
                $('body').append($alertEl);
                setTimeout(function () { $alertEl.remove(); }, 1500);
            }
        });
    },
    submit: function () {
        $(document).on('submit', 'form', function (e) {
            var formValidateResult = validateForm.call(this, e);
            return formValidateResult;
        });
    },

    buttonClick: function () {
        $('form button[type="submit"], form input[type="submit"]').on('click', function () {
            // clear all errors when trying to submit the form
            clearForm($(this).parents('form'));
        });
    },

    foucusout: function () {
        $(document).on('focusout', 'input, select', function (e) {
            if (!($(e.relatedTarget) && $(e.relatedTarget).hasClass('btn'))) {
                $(this).parent().find('.invalid-feedback').show();
                validateFormElement.call($(this)[0], e);
            }
        });
    },

    selectShipping: function () {
        $(document).on('change', 'input, select', function (e, status) {
            $(this).parent().find('.invalid-feedback').show();
            if (status !== 'nofocus') {
                validateFormElement.call($(this)[0], e);
            }
        });
    },

    functions: {
        validateForm: function (form, event) {
            validateForm.call($(form), event || null);
        },
        formValidate: function (form, event) {
            return formValidate.call($(form), event || null);
        },
        clearForm: clearForm
    }
};
